<template>
  <div
    class="mds-notification mds-notification--top-center"
    :class="{ 'mds-notification--active': show }"
  >
    <div
      class="mds-notification__item mds-notification__item--dismissible"
      :class="`${displayCssClass} ${notificationTypeCssClass} ${tintedCssClass}`"
      role="alertdialog"
    >
      <div class="mds-notification__status">
        <svg class="mds-icon mds-notification__icon" aria-hidden="true">
          <use v-if="isSuccess" xlink:href="static/mds/icons/mds.svg#check">
            <title>Success</title>
          </use>
          <use v-else-if="isInfo" xlink:href="static/mds/icons/mds.svg#info-circle--s">
            <title>Information</title>
          </use>
          <use v-else xlink:href="static/mds/icons/mds.svg#alert">
            <title>Alert</title>
          </use>
        </svg>
      </div>
      <div class="mds-notification__body">
        <div class="mds-notification__content">
          <strong v-if="title" class="mds-notification__title">{{ title }}</strong>
          <p v-if="message" class="mds-notification__message" v-html="message"></p>
          <p v-if="errorMessage" class="mds-notification__message error-message">{{ errorMessage }}</p>
          <button
            v-if="action"
            class="mds-button mds-button--small mds-button--secondary mds-button__action-button"
            type="button"
            @click="browseTo(action)"
          >
            {{ actionLabel }}
          </button>
        </div>
      </div>
      <button
        class="mds-button mds-notification__dismiss-button mds-button--small mds-button--icon-only"
        type="button"
        @click="closeNotification"
      >
        <svg class="mds-icon mds-button__icon mds-button__icon--right" aria-hidden="true">
          <use xlink:href="static/mds/icons/mds.svg#remove--s">
            <title>Close</title>
          </use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Notification',
  props: {
    showContactInfoEnabled: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    if (this.show === true) {
      this.timeout = setTimeout(() => {
        this.closeNotification();
      }, this.maxTime * 1000);
    }
  },
  data() {
    return {
      timeout: null,
      maxTime: 10,
    };
  },
  computed: {
    ...mapState({
      show: (state) => state.notification.show,
      notificationType: (state) => state.notification.settings.notificationType,
      title: (state) => state.notification.settings.title,
      message: (state) => state.notification.settings.message,
      action: (state) => state.notification.settings.action,
      actionLabel: (state) => state.notification.settings.actionLabel,
      showContactInfo: (state) => state.notification.settings.showContactInfo,
      tinted: (state) => state.notification.settings.tinted,
    }),
    isSuccess() {
      return this.notificationType === 'success';
    },
    isAlert() {
      return this.notificationType !== 'success' && this.notificationType !== 'info';
    },
    isInfo() {
      return this.notificationType === 'info';
    },
    errorMessage() {
      if (this.notificationType === 'error' && this.showContactInfoEnabled && this.showContactInfo) {
        return 'Try it later. If your error continues, email support@morningstar.com.';
      }
      return null;
    },
    displayCssClass() {
      return this.show ? 'mds-notification__item--visible' : '';
    },
    notificationTypeCssClass() {
      return `mds-notification__item--${this.notificationType}`;
    },
    tintedCssClass() {
      return this.tinted ? 'mds-notification__item--tinted' : '';
    },
  },
  methods: {
    ...mapActions({
      closeNotification: 'closeNotification',
    }),
    browseTo(destination) {
      this.$router.push(`/${destination}`);
    },
  },
  watch: {
    show(newValue) {
      if (newValue === true) {
        this.timeout = setTimeout(() => {
          this.closeNotification();
        }, this.maxTime * 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mds-notification {
  z-index: 1001;
}
</style>
